import React, { useState, useEffect } from 'react'
import { Api } from 'services'
import styles from './modal.module.scss'
import { Tag, ProgressBar } from 'components'
import { wrapTags } from '../../utils/regex';
const BRAND = process.env.REACT_APP_BRAND;
const BRAND_ID = process.env.REACT_APP_BRAND_ID
const QuestionsBrand = require(`../../services/${process.env.REACT_APP_BRAND}/questions/questions.json`)
const GendersBrand = require(`../../services/${process.env.REACT_APP_BRAND}/genders/genders.json`)

function Modal({ handleClick, sendData, sendFilterPrice, setSelectedGenders }) {
  const questions = QuestionsBrand
  const [totalSteps] = useState(questions.length)
  const [currentStep, setCurrentStep] = useState(0)
  const [currentIntention, setCurrentIntention] = useState(questions[0].intention);
  const typeQuestions = {
    single: 'Selecione uma opção',
    multiple: 'Selecione uma ou mais opções',
  }

  useEffect(() => {
    setCurrentIntention(questions[currentStep].intention);
  }, [questions, currentStep]);

  function handleOnSubmit(event) {
    if (!answersValidator(currentIntention)) return;

    event.preventDefault()
    const values = [...answersSelectedAll()].map(i => {
      return {
        label: i.name,
        value: i.value,
        icon: i.dataset.icon,
        idQuestion: i.dataset.questionId,
      }
    })

    sendApi(values)
    sendData(values)
    handleClick()
    goToTop()
  }

  function answersSelectedAll (){
    return (
      document.querySelectorAll(
      '#js-question-form input:checked'
      )
    )
  }

  function answersSelectedChecker (){
    return (
      document.querySelectorAll(`.step-${currentStep} input:checked`).length
    )
  }

  function answersValidator (intention){
    if(intention === 'tagging') {
      return displayMessageValidator()
    }
  }

  function displayMessageValidator (){
    const elMsgAlert = document.querySelector(`.step-${currentStep} p`)
    if(answersSelectedChecker()){
      elMsgAlert.style.display='none'
      return true
    }
    elMsgAlert.style.display='flex'
  }

  function removedDuplicate(values) {
    return Object.values(
      values.reduce((accumulator, currentValue) => {
        accumulator[currentValue.idQuestion] = currentValue
        return accumulator
      }, {})
    )
  }

  function sendApi(values) {
    const constructArrData = removedDuplicate(values)
    const filteredArrData = constructArrData.map(item => {
      let answers = ''
      values.forEach(i => {
        if (item.idQuestion === i.idQuestion) {
          answers = [answers, i.value].join()
        }
      })

      return {
        idQuestion: item.idQuestion,
        answer: answers.slice(1),
      }
    })

    const dataApi = {
      idBrand: BRAND_ID,
      giftFinderAnswerDto: filteredArrData,
    }
    Api().post(dataApi)
  }

  function goToTop() {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })
  }

  function renderNextButton(intention) {
    return (
      <button
        type="button"
        className={`ty-button ty-button--large`}
        onClick={() => goToNextStep(intention)}
      >
        CONTINUAR
      </button>
    )
  }

  function renderFinishButton() {
    return (
      <button
        type="button"
        className={`ty-button ty-button--large`}
        onClick={handleOnSubmit}
      >
        FINALIZAR
      </button>
    )
  }

  function getSelectedGenders(selectedGender) {
    return GendersBrand.filter(gender => gender.categories.includes(selectedGender));
  }

  function handleClickTag(question, response) {
    const intention = question.intention;
    if (intention === 'filter') {
      sendFilterPrice(response)
    } else if (intention === 'tagging') {
      if (GendersBrand && question.saveGender) {
        setSelectedGenders(getSelectedGenders(response.label));
      }

      displayMessageValidator()
    }
  }

  function renderQuestions() {
    const isTheLastQuestion = currentStep === totalSteps - 1

    return questions.map((question, index) => {
      return (
        <div
          key={index}
          className={
            index === currentStep ? styles.modal__show : styles.modal__hide
          }
        >
          <div className={styles.modal__question_wrapper}>
            <div className={styles.modal__question_content}>
              <h2 className={styles.modal__title}>
                { wrapTags(question.title, 'bold').map(item => item) }
              </h2>
              <p className={styles.modal__subtitle}>
                {typeQuestions[question.type]}
              </p>
              <div
                className={styles.modal__tags + ` steps step-${index}`}
              >
                {_renderAnswers(question)}

                {question.intention === 'tagging' && <p className={styles.modal__alert}>*{typeQuestions[question.type]} para continuar.</p>}
              </div>
            </div>
            <div className={styles.modal__submit}>
              {isTheLastQuestion ? renderFinishButton() : renderNextButton()}
            </div>
          </div>
        </div>
      )
    })

    function _renderAnswers(question) {
      return question?.responses.map((response, index) => {
        return (
          <Tag
            key={index}
            icon={response.icon}
            type={question.type}
            name={question.name}
            questionId={question.id}
            value={response.label}
            genderId={question.genderId}
            handleClick={() => handleClickTag(question, response)}
          >
            {response.label}
          </Tag>
        )
      })
    }
  }

  function goToNextStep() {
    if(answersValidator(currentIntention) || currentIntention !== 'tagging') {
      if (currentStep < totalSteps) {
        setCurrentStep(currentStep + 1)
        return
      }
    }
  }

  return (
    <div className={styles.modal}>
      <div className={styles.modal__overlay} onClick={handleClick}></div>
      <div className={styles.modal__absolute_wrapper}>
        <div className={styles.modal__wrapper}>
          {(BRAND === 'anacapri' || BRAND === 'zzmall') && (
            <ProgressBar totalSteps={totalSteps} currentStep={currentStep + 1} />
          )}

          <form id="js-question-form" className={styles.modal__form}>
            {renderQuestions()}
          </form>
        </div>
      </div>
    </div>
  )
}

export { Modal }
